export default class PermissionsService {
    static get $inject() {
        return ['$state'];
    }
    constructor() {
        this.permissions = [];
    }

    setPermissions(permissions) {
        this.permissions = permissions;
    }

    isHavePermission(permission) {

        let per = this.permissions;
        let havePermission = _.find(per, function (o) {
            return ~o.indexOf(permission);
        });

        return Boolean(havePermission);
    }

    clearServiceCache() {
        this.permissions = [];
    }

}


/** WEBPACK FOOTER **
 ** ./src/services/api/api.premissions.service.js
 **/